export const CALL_STATE = {
  NEW: 'NEW',
  FETCHING: 'FETCHING',
  SUCCESS: 'SUCCESS',
  ERROR: 'ERROR',
}

export const dummy = null
